export default __webpack_public_path__ + "images/V5.eb6f8ba.png";